export const couponsConstants = {
    COUPONS_SUCCESS: 'COUPONS_SUCCESS',
    COUPONS_FETCH: 'COUPONS_FETCH',
    COUPONS_ERROR: 'COUPONS_ERROR',
    COUPONS_SUCCESS_ALL: 'COUPONS_SUCCESS_ALL',
    COUPONS_SET_COUPONS: 'COUPONS_SET_COUPONS',
    COUPONS_UPDATE_STATUS: 'COUPONS_UPDATE_STATUS',
    COUPONS_RESET_ALL: 'COUPONS_RESET_ALL',
};

export const CouponType = {
    PercentageOff: 0,
    AmountOff: 1,
    FreeItem: 2,
};

export const CouponStatus = {
    Paused: 0,
    Active: 1,
    Archived: 2,
};
